import { SilverbackPageContext } from '@amazeelabs/gatsby-source-silverback';
import { ContentRoute, Route } from '@caritas/ui';
import { WindowLocation } from '@reach/router';
import { graphql, HeadProps, PageProps } from 'gatsby';
import React from 'react';

import { buildMetadata } from '../commons/metadata';
import { mapContentPage } from '../fragments/ContentPage.mappers';
import { useTranslations } from '../fragments/Translations.mappers';
import { Page, PageHead } from '../utils/Page';
import { getMessagesFromLocation } from '../utils/status-messages';

export const query = graphql`
  query ContentPageTemplate($remoteId: String!) {
    drupalContentPage(remoteId: { eq: $remoteId }) {
      ...ContentPage
    }
  }
`;

type ContentPageTemplateQuery = {
  drupalContentPage: ContentPageFragment;
};

export const Head = ({
  data,
  pageContext,
}: HeadProps<ContentPageTemplateQuery, SilverbackPageContext>) => {
  return data.drupalContentPage ? (
    <PageHead
      pageContext={pageContext}
      pageMetadata={buildMetadata(data.drupalContentPage, pageContext)}
    />
  ) : undefined;
};

export default function ContentPageTemplate({
  data,
  pageContext,
  path,
  location,
}: PageProps<
  ContentPageTemplateQuery,
  SilverbackPageContext,
  WindowLocation['state'] & { messages?: Array<string> }
>) {
  const content = data.drupalContentPage!;
  const translations = useTranslations(pageContext);

  return (
    <Page
      pageContext={pageContext}
      donationPurpose={content.donationPurpose}
      donationDescription={content.donationDescription}
      headerDisplayMode={content.header.displayMode}
    >
      <Route
        definition={ContentRoute}
        input={mapContentPage(
          content,
          pageContext,
          path,
          getMessagesFromLocation(location),
        )}
        intl={translations}
      />
    </Page>
  );
}
